import {Injectable, NgZone} from '@angular/core';
import {TokenStorageService} from '../shared/service/token-storage.service';
import {Router} from '@angular/router';


/*
  Author - Sajith Henarath
 */

@Injectable({
  providedIn: 'root'
})

export class InactivityService {
  private logoutTimer: any;

  //ten minutes timer = 600000
  //one minute for testing = 60000
  private readonly INACTIVITY_TIMEOUT = 600000;

  constructor(private tokenStorageService: TokenStorageService,
              private router: Router,
              private ngZone: NgZone) {
    // console.log('Timer started!');
    // this.setupInactivityListeners();

  }

  private setupInactivityListeners() {
    // this.ngZone.runOutsideAngular(() => {
    //   const events = ['mousemove', 'keydown', 'click', 'scroll'];
    //   const throttleTime = 10000;
    //   let lastEventTime = 0;
    //
    //   events.forEach(event => {
    //     window.addEventListener(event, () => {
    //       const now = Date.now();
    //       if (now - lastEventTime >= throttleTime) {
    //         lastEventTime = now;
    //         this.resetTimer();
    //       }
    //     });
    //   });
    // });
    //
    // this.resetTimer();

  }

  //reset timer and set call back to log out method
  private resetTimer() {
    // console.log('RESET');
    // if (this.logoutTimer)
    //   clearTimeout(this.logoutTimer);
    //
    // this.logoutTimer = setTimeout(() => this.logout(), this.INACTIVITY_TIMEOUT);

  }

  private logout() {
    // console.log('AUTO LOGGED OUT');
    // this.ngZone.run(() => {
    //   this.tokenStorageService.signOut(true);
    //
    // });
  }

}




